module.exports = __webpack_public_path__ + "img/tel.ea577aaf.jpg";